import { styled } from 'styled-components'
import { MinusIcon, PlusIcon } from '../../../../icons'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
`

export const Control = styled.button`
  width: 25px;
  height: 25px;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  color: ${({ theme }) => theme.colors.black};

  &[aria-disabled='true'] {
    cursor: default;
    opacity: 0.3;
  }
`

export const Count = styled.span`
  min-width: 20px;
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  line-height: 140%;
  color: ${({ theme }) => theme.colors.black};
`

export const Minus = styled(MinusIcon)`
  width: 12px;
  height: 12px;
`

export const Plus = styled(PlusIcon)`
  width: 12px;
  height: 12px;
`
